export const CONTACT = {
    FETCH_CONTACT: {
        MAIN: 'FETCH_CONTACT',
        SUCCESS: 'FETCH_CONTACT_SUCCESS',
        FAILURE: 'FETCH_CONTACT_FAILURE'
    },
};
